export const featureItems = [
  {
    illustration: 'mobility-1',
    headText: 'Mobilidade',
    bodyText: 'Faça vistorias digitais usando o aplicativo Owli Vistoriador.'
  },
  {
    illustration: 'flexibility-2',
    headText: 'Flexibilidade',
    bodyText: 'Terceirize suas vistorias com a integração à Rede Vistorias.'
  },
  {
    illustration: 'facility',
    headText: 'Facilidade',
    bodyText: 'Crie modelos de laudos de vistorias dentro do sistema.'
  },
  {
    illustration: 'integration',
    headText: 'Integração',
    bodyText: 'Solução integrada ao sistema de gestão Superlógica.'
  }
]
